import { veliDuyuruKarti } from "../../components/announcements.js";
import { subeBul } from "../../domain/context.js";
// ============================================================
// Veli portalı — Bugün (§2)
//
// Velinin ilk açtığı ekran. Tek soruya cevap verir:
// "Çocuğum bugün nasıl?"
// ============================================================

import { ATT, card, emptyNote, sectionTitle } from "../../components/ui.js";
import { BUGUN } from "../../config.js";
import { avatar } from "../../lib/avatar.js";
import { age, esc, fmtDate } from "../../lib/fmt.js";
import { cocuklarim } from "../../domain/auth.js";
import { alerjiler } from "../../domain/students.js";
import { ogrencininOlaylari } from "../../domain/health.js";

export function viewVeliBugun() {
  const kids = cocuklarim();
  if (!kids.length) return emptyNote("Kayıtlı çocuk bulunamadı.");

  return `
  <p class="text-sm text-inksoft mb-4">
    ${fmtDate(BUGUN)} · Öğretmenin gün içinde girdiği kayıtlar burada görünür.
  </p>
  <div class="grid gap-4 ${kids.length > 1 ? "lg:grid-cols-2" : ""} items-start">
    ${kids.map(cocukKarti).join("")}
    ${veliDuyuruKarti(kids[0])}
  </div>`;
}

function cocukKarti(s) {
  const t = subeBul(s.branchId);
  const c = t.classes.find(x => x.id === s.classId);
  const a = t.attendance[s.id];
  const rapor = t.dailyReports.find(r => r.studentId === s.id);
  const olaylar = ogrencininOlaylari(s.id, t.id).filter(o => o.at.startsWith(BUGUN));

  return card(`
    <div class="h-2.5 rounded-t-2xl" style="background:${c.color}"></div>
    <div class="p-5">
      <div class="flex items-center gap-3">
        ${avatar(s, "w-12 h-12")}
        <div class="min-w-0 flex-1">
          <div class="font-display font-bold text-lg truncate">${esc(s.name)}</div>
          <div class="text-xs text-inksoft">${esc(c.name)} · ${age(s.birthDate)}</div>
        </div>
        <span class="text-[11px] font-bold rounded-full px-2.5 py-1 shrink-0 ${ATT[a.status].chip}">
          ${ATT[a.status].label}
        </span>
      </div>

      <!-- Giriş / çıkış -->
      <div class="grid grid-cols-2 gap-2 mt-4">
        <div class="rounded-xl bg-paper p-3">
          <div class="text-[11px] font-bold text-inksoft uppercase">Giriş</div>
          <div class="font-display font-bold text-lg">${a.in ?? "—"}</div>
        </div>
        <div class="rounded-xl bg-paper p-3">
          <div class="text-[11px] font-bold text-inksoft uppercase">Çıkış</div>
          <div class="font-display font-bold text-lg">${a.out ?? "—"}</div>
          ${a.outBy ? `<div class="text-[11px] text-inksoft truncate">${esc(a.outBy.name)} aldı</div>` : ""}
        </div>
      </div>

      ${a.reason ? `<div class="text-xs text-inksoft mt-2">${esc(a.reason)}</div>` : ""}

      <!-- Günlük rapor -->
      <div class="mt-4">
        ${sectionTitle("Günün Raporu")}
        ${rapor ? `
          <dl class="space-y-2 text-sm">
            <div class="flex gap-2"><dt class="w-24 shrink-0 text-inksoft text-[11px] font-bold uppercase pt-0.5">Kahvaltı</dt><dd>${esc(rapor.meals.kahvalti)}</dd></div>
            <div class="flex gap-2"><dt class="w-24 shrink-0 text-inksoft text-[11px] font-bold uppercase pt-0.5">Öğle</dt><dd>${esc(rapor.meals.ogle)}</dd></div>
            <div class="flex gap-2"><dt class="w-24 shrink-0 text-inksoft text-[11px] font-bold uppercase pt-0.5">İkindi</dt><dd>${esc(rapor.meals.ikindi)}</dd></div>
            <div class="flex gap-2"><dt class="w-24 shrink-0 text-inksoft text-[11px] font-bold uppercase pt-0.5">Uyku</dt><dd>${esc(rapor.sleep)}</dd></div>
            <div class="flex gap-2"><dt class="w-24 shrink-0 text-inksoft text-[11px] font-bold uppercase pt-0.5">Ruh hâli</dt><dd>${esc(rapor.mood)}</dd></div>
            <div class="flex gap-2"><dt class="w-24 shrink-0 text-inksoft text-[11px] font-bold uppercase pt-0.5">Tuvalet</dt><dd>${esc(rapor.toilet)}</dd></div>
          </dl>
          ${rapor.note ? `<div class="rounded-xl bg-teal-soft p-3 text-sm mt-3">${esc(rapor.note)}</div>` : ""}`
        : emptyNote("Bugünün raporu henüz girilmedi.")}
      </div>

      <!-- Bugünkü olaylar -->
      ${olaylar.length ? `
        <div class="mt-4">
          ${sectionTitle("Bugün Yaşananlar")}
          ${olaylar.map(o => `
            <div class="rounded-xl border-2 border-coral bg-coral-soft p-3 mb-2">
              <div class="text-sm font-semibold text-coral">${esc(o.location)} · ${esc(o.at.slice(11))}</div>
              <div class="text-xs mt-1">${esc(o.description)}</div>
              <div class="text-xs mt-1"><span class="font-semibold">Yapılan:</span> ${esc(o.firstAid)}</div>
              ${o.followUp ? `<div class="text-[11px] text-inksoft mt-1">${esc(o.followUp)}</div>` : ""}
            </div>`).join("")}
        </div>` : ""}

      <!-- Kayıtlı alerji hatırlatması -->
      ${alerjiler(s, t.id).length ? `
        <div class="text-[11px] text-inksoft mt-4 pt-3 border-t border-line">
          Kayıtlı alerji: ${alerjiler(s, t.id).map(x => esc(x.name)).join(", ")} —
          değişiklik varsa mesaj bölümünden bildirin.
        </div>` : ""}
    </div>`, "min-w-0");
}
